<template>
  <aside
    v-on-clickaway="clickOutside"
    class="search-container is-pulled-right columns search menu has-text-centered"
  >
    <div class="column box">
      <div class="columns is-centered">
        <div :class="{'is-loading':searching}" class="column search-display-area is-11">
          <h1 class="course-name title has-text-left is-4" has-text-centered>Search</h1>
          <div class="field">
            <div class="control">
              <input
                class="input"
                v-model="searchTerm"
                v-on:keyup.enter="search()"
                type="text"
                placeholder
              />
            </div>
          </div>
          <div class="has-text-left" v-if="results.module">
            <a @click="showModules =! showModules">
              Modules
              <span class="icon">
                <font-awesome-icon class="arrowIndicator" :icon="activeIcon(showModules)" />
              </span>
            </a>
            <div class="indent" v-show="showModules">
              <div v-for="(module,i) in results.module" :key="i">
                <a @click="gotoRoute(module.url)">{{trimContent(module.content)}}</a>
              </div>
            </div>
          </div>
          <div class="has-text-left" v-if="results.lesson">
            <a @click="showLessons =! showLessons">
              Lessons
              <span class="icon">
                <font-awesome-icon class="arrowIndicator" :icon="activeIcon(showLessons)" />
              </span>
            </a>
            <div class="indent" v-show="showLessons">
              <div v-for="(lesson,i) in results.lesson" :key="i">
                <a @click="gotoLesson(lesson.url)">{{trimContent(lesson.content)}}</a>
              </div>
            </div>
          </div>
          <div class="has-text-left" v-if="results.forum_topic">
            <a @click="showTopics =! showTopics">
              Forum Topics
              <span class="icon">
                <font-awesome-icon class="arrowIndicator" :icon="activeIcon(showTopics)" />
              </span>
            </a>
            <div class="indent" v-show="showTopics">
              <div v-for="(topic,i) in results.forum_topic" :key="i">
                <a @click="gotoTopic(topic.id)">{{trimContent(topic.content)}}</a>
              </div>
            </div>
          </div>
          <div class="has-text-left" v-if="results.forum_topic_post">
            <a @click="showPosts =! showPosts">
              Forum Posts
              <span class="icon">
                <font-awesome-icon class="arrowIndicator" :icon="activeIcon(showPosts)" />
              </span>
            </a>
            <div class="indent" v-show="showPosts">
              <div v-for="(post,i) in results.forum_topic_post" :key="i">
                <a @click="gotoRoute(post.url)">{{trimContent(post.content)}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import BaseHelper from "@/helpers/BaseHelper";
import { CourseClient } from "../../clients/CourseClient";
import { mapState } from "vuex";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "SearchSideBar",
  data() {
    return {
      searchTerm: "",
      showTopics: false,
      showPosts: false,
      showModules: false,
      showLessons: false
    };
  },
  computed: {
    ...mapState({
      results(state) {
        return state.search.results;
      },
      searching(state) {
        return state.search.searching;
      },
      display(state) {
        return state.search.displaySearchBar;
      }
    })
  },
  mixins: [BaseHelper, clickaway],
  methods: {
    gotoLesson(url) {
      this.$store.dispatch("search/setLessonTerm", this.searchTerm);
      this.gotoRoute(url);
    },
    trimContent(content) {
      if (content.length > 50) {
        return content.substring(0, 49) + "...";
      } else {
        return content;
      }
    },
    clickOutside() {
      if (this.display == true) {
        this.$store.dispatch("search/setDisplay", false);
      }
    },
    activeIcon(show) {
      if (show) {
        return "angle-down";
      } else {
        return "angle-right";
      }
    },
    search() {
      if (this.searchTerm.length != 0) {
        this.$store.dispatch("search/sendSearch", this.searchTerm);
      }
    },
    gotoTopic(topicId) {
      this.$store.dispatch("search/setTargetTopic", topicId);
      this.$store.dispatch("search/setNavigate", true);
      this.gotoForum();
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "@/assets/scss/_theme-default.scss";
@import "@/assets/scss/only-lms/searchsidebar.scss";
.search-container {
  position: absolute;
  width: 33%;
  right: 0;
  z-index: 3;
}
.indent {
  padding-left: 1rem;
}

// .float-bar {
//   position: sticky;
//   top: 0;
// }
</style>


